import {useEffect} from 'react';
import {TASK_ACTIONS} from 'utils/constants';
import {connect} from 'react-redux';
import {loadTasks} from '../mytasks/myTasks.action';
import {actionFinished} from '../mytasks/action/taskAction.action';
import {
    getActionParameters,
    getHistoryTasksForRender, getUsersLoggedInData,
    getUsersSettings
} from '../store/application.reducers';
import {showNotification} from '../notifications/notification.action';
import * as logger from 'utils/logger.function';
import {navigateBetweenHistoryTasks} from '../mytasks/action/navigateBetweenTasks.action';
import {useNavigate} from "react-router-dom";
import {useModalContext} from "components/modals/ModalContext";

/**
 * asynchronous part of the task action - showing the dialog, which will execute the action
 * synchronous part of action is inside redux action
 */
export const AsyncTaskActionExecutorHistory = (props) => {
    const navigate = useNavigate();
    const {toggleModal} = useModalContext() || {};
    const actionParameters = props.actionParameters;

    /**
     * opening the modal is a state update on the host, so it cannot happen while rendering.
     * actionParameters is the redux action object, a stable reference until another action is
     * dispatched - so this runs once per requested action rather than on every re-render.
     */
    useEffect(() => {
        // nothing to show
        if (!actionParameters.type) {
            return;
        }

        const tasksForAction = props.tasks.allTasks
            .filter((task) => { // find those matching props.taskIds
                return actionParameters.taskIds.some((taskKeyWanted) => {
                    return taskKeyWanted === task.key;
                });
            });

        /**
         * sometimes, when user has dialog opened and navigates away for some time or changes context
         * the keys for task/history details expire, which then results in empty tasks for the popup
         * so detect this situation and rather hide the popup than check for invalid props inside each popup
         */
        if (tasksForAction.length === 0) {
            logger.error("AsyncTaskActionExecutor", "no task to be shown for these keys: " + actionParameters.taskIds);
            props.actionFinished();
            return;
        }

        const popupProps = {
            closeCallback: props.actionFinished,
            translate: props.translate,
            tasks: tasksForAction,
            showNotification: props.showNotification,
            refreshTaskList: props.loadTasks,
            taskDetails: props.taskDetails
        };

        // according to type either show the modal or execute the action directly ..
        switch (actionParameters.type) {
            case TASK_ACTIONS.EMAIL:
                toggleModal?.(TASK_ACTIONS.EMAIL, {...popupProps, loggedInData: props.loggedInData});
                break;
            case TASK_ACTIONS.NEXT_TASK:
                const nextTaskId = props.navigateBetweenHistoryTasks(tasksForAction[0].key, true);
                navigate(nextTaskId, {replace:true});
                props.actionFinished();
                break;
            case TASK_ACTIONS.PREVIOUS_TASK:
                const previousTaskId =  props.navigateBetweenHistoryTasks(tasksForAction[0].key, false);
                navigate(previousTaskId, {replace: true});
                props.actionFinished();
                break;
            default:
                console.error('unmapped action type: ' + actionParameters.type);

        }
    }, [actionParameters]); // eslint-disable-line react-hooks/exhaustive-deps -- once per action, not per render

    return null;
}


const mapStateToProps = function (store) {
    return {
        tasks: getHistoryTasksForRender(store),
        actionParameters: getActionParameters(store),
        userSettings: getUsersSettings(store),
        loggedInData: getUsersLoggedInData(store)
    };
};

const connected = connect(mapStateToProps, {
    actionFinished,
    showNotification,
    loadTasks,
    navigateBetweenHistoryTasks
})(AsyncTaskActionExecutorHistory);


export default connected;